import { render, staticRenderFns } from "./CopyTrade.vue?vue&type=template&id=ff3373e8"
import script from "./CopyTrade.vue?vue&type=script&lang=js"
export * from "./CopyTrade.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports